import React,{useState,useEffect} from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import leafIcn from '../assets/images/slider-shape-5.png';
import { useNavigate } from "react-router-dom";
import subThemes from "../helper/SubThemes_List";
import reduceicons1 from"../assets/images/icon/homeIcons/theme3icon/icon-1.png";
import reduceicons2 from"../assets/images/icon/homeIcons/theme3icon/icon-2.png";
import reduceicons3 from"../assets/images/icon/homeIcons/theme3icon/icon-3.png";
import reduceicons4 from"../assets/images/icon/homeIcons/theme3icon/icon-4.png";
import reduceicons5 from"../assets/images/icon/homeIcons/theme3icon/icon-5.png";
import reduceicons6 from"../assets/images/icon/homeIcons/theme3icon/icon-6.png";
import reduceicons7 from"../assets/images/icon/homeIcons/theme3icon/icon-7.png";

function ReduceWaste() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  const handleRoute = (data) => {
    localStorage.setItem('sub_themes', subThemes['Reduce Waste'][data].value);
    navigate('/details');
  };
  const [themeData, setThemeData] = useState(null);

  const fetchDetails = async (data) => {
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-participants-details?theme=Reduce Waste`); // Replace with your API URL
      const result = await response.json();
      setThemeData(result?.data); // Store fetched data in state
    } catch (error) {
      console.error("Error fetching theme data:", error);
    }

    
  };

  useEffect(()=>{
    fetchDetails();
  },[])

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
        <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
        </div>
      </section>
      <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Reduce <span className="hdngBrkr">Waste</span> </h2>
          <button className="button green btn-login-signup loginBtnnewhm" style={{position:"absolute", right:"6%"}} onClick={()=>navigate(-1)} >Back</button>       
          <div className="sevenScopeBox">
            <ul className="themeGrid">
              {[
                { label: "Cleanliness Drives", icon: reduceicons1 },
                { label: "Awareness on waste segregation/disposal", icon: reduceicons2 },
                { label: "Donation drives to donate old clothes, toys, furniture etc.", icon: reduceicons3 },
                { label: "Recycled waste art contest", icon: reduceicons4 },
                { label: "Interaction sessions with the rag pickers/ small junk shop dealers from the nearby locality", icon: reduceicons5 },
                { label: "Installation of 2-bin system in classroom", icon: reduceicons6 },
                { label: "Others", icon: reduceicons7 }
              ].map((theme, index) => (
                <li key={index} onClick={() => handleRoute(index)}>
                  <div className="themeBox orange3">
                    <div className="themeBoxIcn"><img src={theme.icon} alt="" /></div>
                    <div className="themeBoxCnt">{theme.label}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='stackHolderSec'>
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          {/* <h2><span className="hdngBrkr">Stakeholders</span> Involved</h2> */}
          <div className="stackHldrCntDiv">
  <div className="row">
    <div className="col-6 stackLft">
      <h2 className="sbHdng">participation AT A GLANCE</h2>
      <div className="stackLftIn">
        <ul>
          <li>
             States/UTs <span>{36}</span>
          </li>
          <li>
            Districts <span>{themeData ? themeData.districts : 0}</span>
          </li>
          <li>
            Total Schools <span>{themeData ? themeData.totalSchools : 0}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
        </div>
      </section>
    </>
  );
}

export default ReduceWaste;
